import { useState } from 'react';

import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

// On-screen diameter every animation is scaled to, so they read as the same size.
const CIRCLE_SIZE = 145;

// Each circle fills a different fraction of its own artboard, so the render width has to be
// derived from that fraction rather than shared.
const bootstrapAnimations = [
  { data: lottieAnimations.water, artboardFraction: 0.4 },
  { data: lottieAnimations.circleInParts, artboardFraction: 0.4 },
  { data: lottieAnimations.circleLoading, artboardFraction: 0.775 },
];

export const BootstrapLoading = () => {
  const [animation] = useState(
    () => bootstrapAnimations[Math.floor(Math.random() * bootstrapAnimations.length)],
  );

  return (
    <Box sx={loadingContainerSx}>
      <Lottie
        animationData={animation.data}
        loop
        style={{ width: CIRCLE_SIZE / animation.artboardFraction }}
      />
    </Box>
  );
};

// Reads the token directly so this works without a ThemeProvider.
const loadingContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100dvh',
  backgroundColor: COLOR_TOKENS['Beige/25'],
};
